// Roughly what a full-width form control fits before truncating; past this a count reads better.
const MULTIPLE_SUMMARY_MAX_CHARS = 45;

/**
 * What a closed multi-select field reads as: the picks by name, or a count once they outgrow the
 * control.
 *
 * Base UI keeps a combobox's input value separate from its selection, so the closed field would
 * otherwise read blank however much is picked.
 */
export function multipleSelectionSummary(
  picked: ReadonlyArray<{ label: string }>,
  placeholder: string,
): string {
  if (picked.length === 0) return placeholder;
  const names = picked.map((option) => option.label).join(', ');
  return names.length <= MULTIPLE_SUMMARY_MAX_CHARS ? names : `${picked.length} selected`;
}
